import actionTypes from '../actions/actionTypes';

export default function(state = false, action = {}) {
    if (action.type === actionTypes.CHANGE_AUTHORIZED) {
        return action.value;
    } else {
        return state;
    }
}
